<script>
import {mapState} from "vuex";
import {EF_TRACKING_URL} from "@/paths/constants";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      loading: null,
    }
  },

  computed: {
    ...mapState([
      'fields',
      'fieldsFromUrl',
      'fieldsFromStorage'
    ])
  },

  created() {
    this.answers = {
      'male': [
        { field: 'gender', value: 'Male' },
        { field: 'gender_0_1', value: 0 },
        { field: 'gender_m_f', value: 'M' },
      ],
      'female': [
        { field: 'gender', value: 'Female' },
        { field: 'gender_0_1', value: 1 },
        { field: 'gender_m_f', value: 'F' },
      ],
    }

    if (this.prepare) {
      const valueFromUrl = this.fieldsFromUrl['gender'] === undefined ? '' : this.fieldsFromUrl['gender'].toLowerCase()
      if (Object.keys(this.answers).includes(valueFromUrl)) {
        this.setAnswer(valueFromUrl)
      } else {
        const valueFromStorage = this.fieldsFromStorage['gender'] === undefined ? '' : this.fieldsFromStorage['gender'].toLowerCase()
        if (Object.keys(this.answers).includes(valueFromStorage)) {
          this.setAnswer(valueFromStorage)
          return
        }
        this.$emit('show-this-step')
      }
    }
  },

  methods: {
    async setAnswer(answer) {
      this.loading = answer
      this.$store.dispatch('setAnswers', this.answers[answer])
      this.$emit('next-step')
      // await this.progressionTracking();
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "38" : "53"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },
  }
}
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">
          What is your gender?
        </h2>
        <div class="answers-box">
          <b-button
            class="answer-button"
            :loading="loading === 'male'"
            :disabled="loading !== null"
            @click="setAnswer('male')"
          >
            Male
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'female'"
            :disabled="loading !== null"
            @click="setAnswer('female')"
          >
            Female
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
